import { Modal as ChakraModal, ModalProps } from '@chakra-ui/react'

import { useAppSelector } from '@/redux/hooks'
import { selectVideoWallIsOpen } from '@/redux/videoWall/videoWallSlice'

/**
 * App-wide Modal. Behaves exactly like Chakra's Modal, except it yields its
 * focus trap while the full-screen Video Wall overlay is open — see the
 * {@link Drawer} wrapper for the full rationale. Import this instead of Chakra's
 * Modal everywhere (enforced by ESLint).
 */
export const Modal = (props: ModalProps) => {
  const isVideoWallOpen = useAppSelector(selectVideoWallIsOpen)
  const isFocusTrapEnabled = !isVideoWallOpen

  return (
    <ChakraModal
      {...props}
      closeOnEsc={(props.closeOnEsc ?? true) && isFocusTrapEnabled}
      trapFocus={(props.trapFocus ?? true) && isFocusTrapEnabled}
      useInert={(props.useInert ?? true) && isFocusTrapEnabled}
    />
  )
}
